import { action, EmptyAction, PayloadAction } from 'typesafe-actions';

import { CorporateData, IntegratorData, ValidationData } from '@types';

import { userInputActions, UserInputState } from './userInput.types';

export const saveUserInput = (data: UserInputState): PayloadAction<string, UserInputState> =>
	action(userInputActions.saveUserInput, data);

export const saveCorporateDataFormIsValid = (data: ValidationData): PayloadAction<string, ValidationData> =>
	action(userInputActions.saveCorporateDataFormIsValidInput, data);

export const saveCorporateDataFormInput = (data: CorporateData): PayloadAction<string, CorporateData> =>
	action(userInputActions.saveCorporateDataFormInput, data);

export const saveIntegratorDataFormIsValid = (data: ValidationData): PayloadAction<string, ValidationData> =>
	action(userInputActions.saveIntegratorDataFormIsValidInput, data);

export const saveIntegratorDataFormInput = (data: IntegratorData): PayloadAction<string, IntegratorData> =>
	action(userInputActions.saveIntegratorDataFormInput, data);

export const clearUserInput = (): EmptyAction<string> => action(userInputActions.clearUserInput);

export const clearIntegratorFormInput = (): EmptyAction<string> => action(userInputActions.clearIntegratorFormInput);
